/**
 * Filters JavaScript singleton module
 */
var Filters = (function($) {
  function initFilters() {
    $(".blog-filters__cta").on("click", function(e) {
      e.preventDefault();

      var $this = $(this);
      var selectedCategory = $this.data("category");

      $(".blog-filters__cta").removeClass("blog-filters__cta--active");
      $this.addClass("blog-filters__cta--active");

      if (selectedCategory === "todo") {
        $(".blog-lister-block").show();
      } else {
        $(".blog-lister-block").each(function() {
          var categories = $(this)
            .data("category")
            .split(" ");
          if (categories.includes(selectedCategory)) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      }
    });
  }

  function init() {
    if (!$(".blog-filters").length) {
      return;
    }
    initFilters();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Filters.init);
